import { TwoStepPasswordlessConfirmation } from './TwoStepPasswordlessConfirmation.js';
export default TwoStepPasswordlessConfirmation;
//# sourceMappingURL=index.js.map